import {filter, map, shareReplay} from 'rxjs/operators';
import {uiMsg$} from '@/ui';

export interface FUToken {
  type: 'token-update';
  token: string;
  platform?: string
}
export const userToken$ = uiMsg$.pipe(
  filter((o) => o.type === 'token-update'),
  map((o: FUToken) => o),
  shareReplay(1)
);

userToken$.subscribe();

export interface FULogout {
  type: 'user-logout';
}
export const logout$ = uiMsg$.pipe(filter((o) => o.type === 'user-logout'));
export const login$ = userToken$;
